import { Badge, Col, Container, Row } from "reactstrap";
import MainLayout from "../../layouts/MainLayout";
import './styles.css';
import PropertyCard from "../../components/Cards/PropertyCard";
import { API_URL, STORAGE_URL } from "../../utils/constants";
import { useEffect, useState } from "react";
import HomeSearchForm from "./Forms/Search";
import { Link, useLocation } from "react-router-dom";
import DefaultButton from "../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import BannerCarousel from "./Slider";
import FullscreenAd from "./Modals/ads";

function HomePage() {
  const { t } = useTranslation();
  const location = useLocation();
  const [propertiesLoading, setPropertiesLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [properties, setProperties] = useState([]);
  const [banners, setBanners] = useState([]);
  const [contentAds, setContentAds] = useState(null);
  const [fullscreenAds, setFullscreenAds] = useState(null);

  const getHomeData = () => {
    const cacheKey = `home_data_${location.search}`;
    const cachedData = sessionStorage.getItem(cacheKey);

    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      setCategories(parsed.categories);
      setStates(parsed.states);
      setProperties(parsed.properties);
      setBanners(parsed.banners || []);
      setContentAds(parsed.contentAds || null);
      const adSeen = sessionStorage.getItem('fullscreen_ad_seen');
      setFullscreenAds(!adSeen ? (parsed.fullscreenAds || null) : null);
      setPropertiesLoading(false);
      return;
    }

    setPropertiesLoading(true);
    fetch(API_URL + '/home', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(r => r.json())
    .then(data => {
      if (data.success) {
        setCategories(data.categories);
        setStates(data.states);
        setProperties(data.properties);
        setContentAds(data.content_ads || null);
        const adSeen = sessionStorage.getItem('fullscreen_ad_seen');
        setFullscreenAds(!adSeen ? (data.fullscreen_ads || null) : null);
        setBanners(data.banners);
        sessionStorage.setItem(cacheKey, JSON.stringify({
          categories: data.categories,
          states: data.states,
          properties: data.properties,
          contentAds: data.content_ads || null,
          fullscreenAds: data.fullscreen_ads || null,
          banners: data.banners
        }));
      }
      setPropertiesLoading(false);
    })
    .catch(() => setPropertiesLoading(false));
  }

  useEffect(() => { getHomeData(); }, [location.search]);

  return (
    <MainLayout>
      {/* Banner carousel */}
      {banners.length > 0 && (
        <section className="home-slider">
          <BannerCarousel banners={banners} />
        </section>
      )}

      {/* Search form */}
      <section className="section-search">
        <Container>
          <HomeSearchForm categories={categories} states={states} />
        </Container>
      </section>

      {/* Properties grid */}
      <section className="mb-5">
        <Container>
          <h2 className="section-title">{t('home.sections.last_ads.title')}</h2>
          {propertiesLoading ? (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          ) : (
            <>
              <Row className="g-3">
                {contentAds && (
                  <Col xl="3" lg="4" md="4" sm="6" xs="12">
                    <div className="property-card position-relative h-100" style={{background:'linear-gradient(135deg,#fafffe,#f0f9f4)'}}>
                      <Link to={'/banner/' + contentAds.id} className="stretched-link" state={{ banner: contentAds }}></Link>
                      <div className="property-card__image-wrap">
                        <img src={STORAGE_URL + contentAds.image_url} alt="" className="property-card__image" />
                        <span className="property-card__badge property-card__badge--paused" style={{background:'rgba(0,0,0,0.45)'}}>ADS</span>
                      </div>
                      <div className="property-card__body">
                        <h5 className="property-card__title">{contentAds.title}</h5>
                      </div>
                    </div>
                  </Col>
                )}

                {properties?.map((data, key) => (
                  <Col xl="3" lg="4" md="4" sm="6" xs="12" key={key}>
                    <PropertyCard property={data} />
                  </Col>
                ))}
              </Row>

              <div className="text-center mt-4 mb-5">
                <Link to="/search">
                  <DefaultButton outline size="lg" className="rounded-pill px-5">
                    {t('home.sections.last_ads.view_more')}
                  </DefaultButton>
                </Link>
              </div>
            </>
          )}
        </Container>
      </section>

      <FullscreenAd
        ad={fullscreenAds}
        isOpen={!!fullscreenAds}
        onClose={() => { sessionStorage.setItem('fullscreen_ad_seen', '1'); setFullscreenAds(null); }}
      />
    </MainLayout>
  );
}

export default HomePage;
